export default __webpack_public_path__ + "static/img/collections-men-capes-bg.88c8465.jpg";